import { Action } from "@/api-schema-enums";
import { useAbility } from "@/casl-provider";
import { cn } from "@/common/helpers/utils";
import type { ReactElement, ReactNode } from "react";
import { Link } from "wouter";
import { getRelationPath, type RelationSubject } from "./relation-path";

interface RelationLinkProps {
  subject: RelationSubject;
  uuid: string;
  children: ReactNode;
  className?: string;
}

export function RelationLink({ subject, uuid, children, className }: RelationLinkProps): ReactElement {
  const ability = useAbility();

  if (!ability.can(Action.Read, subject)) {
    return <span className={className}>{children}</span>;
  }

  return (
    <Link to={getRelationPath(subject, uuid)} className={cn("underline-offset-4 hover:underline", className)}>
      {children}
    </Link>
  );
}
